import { Type } from "class-transformer";
import { EnaioObject } from "src/modules/enaio/shared/EnaioObject";
import { EnaioFrontendSortColumn } from "./EnaioFrontendSortColumn";
import { EnaioFrontendField } from "./EnaioFrontendField";
import { EnaioFrontendColumn } from "./EnaioFrontendColumn";
import { EnaioDocumentResult } from "./EnaioDocumentResult";
import { Utils } from "src/modules/utils/shared/utils";
import { MainAppService } from "src/modules/app-template/services/main-app.service";
import { Objects } from "src/modules/utils/shared/objects";

export class EnaioDocumentFrontendResult {
    //netgen start
    defId: string;
    name: string;
    nameSingular: string;
    documentTypeSelectionGroup: string;
    icon: string;
    boxColor: string;
    hasDocuments = false;
    useSearchBar = false;
    searchBarLabel: string;
    searchBarEnaioField: string;
    @Type(() => EnaioFrontendField)
    searchFields: EnaioFrontendField[];
    canUpload = false;
    writeDefinitionId: string;
    displayObjectTypeColumn = false;
    resultCount = 0;
    childDefId: string;
    @Type(() => EnaioObject)
    parentDocument: EnaioObject;
    parentId: string;
    parentName: string;
    parentObjectName: string;
    @Type(() => EnaioFrontendColumn)
    columns: EnaioFrontendColumn[];
    @Type(() => EnaioFrontendSortColumn)
    sortColumns: EnaioFrontendSortColumn[];
    showMetaData = true;
    allowExportTable = true;
    toStringTemplate: string;
    anonymousOnly = false;
    useSeenMarker = false;
    seenMarkerImplicit = false;
    returnRemarkObjects = false;
    tokenBased = false;
    @Type(() => EnaioDocumentResult)
    documents: EnaioDocumentResult[];
    //netgen end

    getTitle(document: EnaioObject): string {
        return Utils.isNoe(this.toStringTemplate) ? this.name + " " + document.id : Utils.getTemplateFunction(this.toStringTemplate)(document.getMetaDataMap());
    }

    getDisplayName(app: MainAppService): string {
        return app.multilingual ? app.t("documents.frontendDefs." + this.defId + ".name", null, this.name) : this.name;
    }

    translate(app: MainAppService): void {
        if (!app.multilingual) {
            return;
        }

        this.name = this.getDisplayName(app);
        this.nameSingular = app.t("documents.frontendDefs." + this.defId + ".nameSingular", null, this.nameSingular);
        for (let col of this.columns) {
            if (this.documents != null && app.tRegexHas("documents.frontendDefs." + this.defId + ".columnContentTranslation." + col.id)) {
                for (let doc of this.documents) {
                    let field = doc.columns[col.id];
                    if (field != null) {
                        doc.columns[col.id] = app.tRegex("documents.frontendDefs." + this.defId + ".columnContentTranslation." + col.id, Objects.toString(field));
                    }
                }
            }
            col.title = app.t("documents.frontendDefs." + this.defId + ".columns." + col.id, null, col.getTitle());
        }
    }
}
